"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var DlgError = /** @class */ (function (_super) {
    __extends(DlgError, _super);
    function DlgError(props) {
        return _super.call(this, props) || this;
    }
    DlgError.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({
                visible: data.visible,
                message: data.message,
                title: data.title
            });
        });
        this.setState({
            visible: this.props.controller.DATA.visible,
            message: this.props.controller.DATA.message,
            title: this.props.controller.DATA.title
        });
    };
    DlgError.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
    };
    DlgError.prototype.handleClose = function () {
        this.props.controller.Close();
    };
    DlgError.prototype.render = function () {
        return (React.createElement(antd_1.Modal, { title: this.state.title, visible: this.state.visible, wrapClassName: "vertical-center-modal", closable: false, maskClosable: false, footer: React.createElement(antd_1.Button, { type: "danger", onClick: this.handleClose.bind(this) }, "OK") },
            React.createElement("p", null, this.state.message)));
    };
    return DlgError;
}(React.Component));
exports.default = DlgError;



//////////////////
// WEBPACK FOOTER
// ./src/shared/dialogs/ui/DlgError.tsx
// module id = 1066
// module chunks = 0